import * as React from 'react';
import Slider, { SliderProps } from '@mui/material/Slider';
import { alpha, styled } from '@mui/material/styles';

const StyledComponent = styled(Slider)<SliderProps>(({ theme }) => ({
  color: theme.palette.primary.main,
  '& .MuiSlider-thumb': {
    color: theme.palette.primary.main,
    '&:hover, &.Mui-focusVisible': {
      color: theme.palette.primary.main,
      boxShadow: `0px 0px 0px 8px ${alpha(theme.palette.primary.main, 0.16)}`,
    },
    '&.Mui-active': {
      color: theme.palette.primary.main,
      boxShadow: `0px 0px 0px 14px ${alpha(theme.palette.primary.main, 0.16)}`,
    },
  },
  '& .MuiSlider-track': {
    color: theme.palette.primary.main,
  },
  '& .MuiSlider-rail': {
    opacity: 0.5,
    backgroundColor: theme.palette.primary.main,
  },
  '& .MuiSlider-mark': {
    backgroundColor: theme.palette.primary.main,
    height: 8,
    width: 1,
    '&.MuiSlider-markActive': {
      opacity: 1,
      backgroundColor: theme.palette.primary.main,
    },
  },
}));

export default function StyledSlider({ ...props }: SliderProps) {
  return <StyledComponent {...props} />;
}
